import { useMemo } from 'react';
import type { ISocialAccount } from '@components';
import type { MemberSearchQuery_members } from '@frontend/app/queries/types/MemberSearchQuery';
import { memberEngagementRateAdapter, type EngagementRateData } from '@/app/containers/Projects/ProjectsPage/ProspectsList/adapters/member-engagement-rate-adapter';

export interface EngagementRateSectionProps {
  isLoading: boolean;
  engagementData: EngagementRateData;
  engagementRatioSegment?: string;
}

export const useEngagementRateProps = (
  isLoading: boolean,
  socialData?: ISocialAccount | null,
  member?: MemberSearchQuery_members | null
): EngagementRateSectionProps => {
  const engagementData = useMemo((): EngagementRateData => {
    return memberEngagementRateAdapter.extractEngagementRateData({
      member: member || null,
      socialData,
    });
  }, [socialData, member]);

  return {
    isLoading,
    engagementData,
    engagementRatioSegment: socialData?.engagement_ratio_segment,
  };
};
